"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <>
        <div className="hidden md:flex gap-1">
          <div className="h-9 w-16 bg-secondary/50 animate-pulse rounded-md" />
          <div className="h-9 w-16 bg-secondary/50 animate-pulse rounded-md" />
          <div className="h-9 w-16 bg-secondary/50 animate-pulse rounded-md" />
        </div>
        <Button variant="ghost" size="icon" className="md:hidden hover:!bg-transparent focus:!bg-transparent" aria-label="Menu">
          <Menu className="size-6" />
        </Button>
      </>;
  }
  return <>
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="inline-flex items-center justify-center h-9 px-4 py-2 text-sm font-medium rounded-md transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:!bg-transparent focus:!bg-transparent relative group">
                  <span className="relative">
                    {item.label}
                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:w-full" />
                  </span>
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      <Button variant="ghost" size="icon" className="md:hidden hover:!bg-transparent focus:!bg-transparent transition-transform duration-[var(--duration-fast)] active:scale-95" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label={mobileMenuOpen ? "Fermer le menu" : "Ouvrir le menu"}>
        {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </Button>

      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-background border-b shadow-medium md:hidden">
          <nav className="flex flex-col p-4 gap-2">
            {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="px-4 py-3 text-sm font-medium rounded-md hover:bg-accent transition-colors duration-[var(--duration-fast)]" onClick={() => setMobileMenuOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header className={`sticky top-0 z-50 w-full bg-background border-b transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${scrolled ? "h-16 shadow-medium" : "h-24"}`}>
      <div className="container mx-auto px-4 h-full flex items-center justify-between">
        <Link to="/" className="flex items-center hover:!bg-transparent focus:!bg-transparent">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1514089/img/image_pttnlnit.png" alt="JokerStudio" className="h-7" />
        </Link>

        <div className="flex items-center gap-6">
          <MenuProvider menu_id="3">
            <HeaderMenuConsumer />
          </MenuProvider>

          <Button asChild className="hidden md:inline-flex hover:scale-[1.03] hover:!bg-primary-hover focus:!bg-primary transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)]">
            <Link to="/ContactPage">Nous contacter</Link>
          </Button>
        </div>
      </div>
    </header>;
}